// Video v galerii produktu: doplňkový parametr „Video“ s odkazem na YouTube nebo soubor MP4 (zatím jen demo produkt 7324, třída mydemo-product z demo-produkt.js)
let galleryVideo = null;
let videoTexts = null;

function myYoutubeId(url) {
    let parsed;
    try {
        parsed = new URL(url, window.location.href);
    } catch (e) {
        return null;
    }

    if (!/(^|\.)(youtube\.com|youtube-nocookie\.com|youtu\.be)$/i.test(parsed.hostname)) {
        return null;
    }

    let youtubeId = "";
    if (/(^|\.)youtu\.be$/i.test(parsed.hostname)) {
        youtubeId = parsed.pathname.split("/")[1] || "";
    } else if (parsed.pathname.replace(/\/$/, "") === "/watch") {
        youtubeId = parsed.searchParams.get("v") || "";
    } else {
        youtubeId = (parsed.pathname.match(/^\/(?:shorts|embed|live)\/([^/]+)/) || [])[1] || "";
    }

    return /^[\w-]{11}$/.test(youtubeId) ? youtubeId : "";
}

function myGalleryVideo(url) {
    const youtubeId = myYoutubeId(url);
    let $media;

    if (youtubeId === "") {
        console.warn("Video v galerii: nerozpoznaný odkaz na YouTube", url);
        return null;
    }

    if (!youtubeId && !/^(https?:)?\/[^\s]+$/i.test(url)) {
        console.warn("Video v galerii: hodnota parametru není odkaz", url);
        return null;
    }

    if (youtubeId) {
        $media = $("<iframe frameborder='0' tabindex='-1'></iframe>").attr({
            "data-src": "https://www.youtube.com/embed/" + youtubeId + "?autoplay=1&mute=1&controls=0&playsinline=1&rel=0&modestbranding=1&enablejsapi=1",
            "title": $(".p-detail-inner-header h1").text().trim() || "Video",
            "allow": "autoplay; encrypted-media; picture-in-picture",
        });
        // Swiper při průchodu dokola iframe přesune a ten se načte znovu od začátku a ztlumený: náhled se vrátí a zvuk naskočí až s obrazem
        $media.on("load", function () {
            if (!this.getAttribute("src") || this.getAttribute("src") === "about:blank") {
                return;
            }

            const $video = $(this).closest(".mygallery-video");
            if ($video.hasClass("is-click") && !$video.hasClass("is-started")) {
                return;
            }

            this.contentWindow.postMessage(JSON.stringify({ event: "listening", id: youtubeId, channel: "widget" }), "https://www.youtube.com");
            if ($video.hasClass("is-click")) {
                return;
            }

            $video.removeClass("is-playing");
            delete this.dataset.soundRestore;
            if ($video.hasClass("is-sound")) {
                this.dataset.soundLater = "1";
            }
            myVideoCommand($video, $video.hasClass("is-paused") ? "pause" : "play");
        });
    } else {
        $media = $("<video autoplay muted loop playsinline preload='metadata'></video>").attr("src", url);
        $media[0].muted = true;
        $media.on("error", myVideoFailed);
        $media.on("loadedmetadata", function () {
            if (!this.videoWidth) {
                myVideoFailed();
            }
        });
        $media.on("volumechange", function () {
            myVideoSoundState($(this).closest(".mygallery-video"), !this.muted);
        });
    }

    const $video = $("<div class='mygallery-video'></div>")
        .attr("data-type", youtubeId ? "youtube" : "file")
        .data("url", url)
        .data("youtubeId", youtubeId)
        .append($media);

    // Náhled YouTube zakrývá prvky přehrávače, dokud video opravdu nehraje
    if (youtubeId) {
        $("<img class='mygallery-video-poster' alt=''>")
            .data("sources", (/\/shorts\//i.test(url) ? ["oar2", "maxresdefault"] : ["maxresdefault"]).concat("hqdefault"))
            .on("load error", function (e) {
                const sources = $(this).data("sources");
                if ((e.type === "error" || this.naturalWidth <= 120) && sources.length) {
                    $(this).attr("src", "https://i.ytimg.com/vi/" + youtubeId + "/" + sources.shift() + ".jpg");
                }
            })
            .appendTo($video)
            .trigger("error");
    }

    $video.append($("<button type='button' class='mygallery-video-sound'></button>").attr("aria-label", videoTexts.soundOn));

    // YouTube přehrávač video jen vpisuje, pro výřez potřebuje poměr stran videa; smazané nebo soukromé video oEmbed nenajde
    if (youtubeId) {
        $video[0].style.setProperty("--mygallery-video-ratio", /\/shorts\//i.test(url) ? "0.5625" : "1.7778");
        $video.toggleClass("is-vertical", /\/shorts\//i.test(url));
        $.get("https://www.youtube.com/oembed", { url: "https://www.youtube.com/shorts/" + youtubeId, format: "json" }, function (data) {
            if (data && data.width && data.height) {
                $video[0].style.setProperty("--mygallery-video-ratio", String(data.width / data.height));
                $video.toggleClass("is-vertical", data.width < data.height);
                const $poster = $video.find(".mygallery-video-poster");
                if (data.width < data.height && $poster.data("sources")[0] === "hqdefault" && !/\/oar2\./.test($poster.attr("src"))) {
                    $poster.data("sources", ["maxresdefault", "hqdefault"]).attr("src", "https://i.ytimg.com/vi/" + youtubeId + "/oar2.jpg");
                }
            }
        }, "json").fail(function (xhr) {
            if (xhr.status >= 400 && xhr.status < 500) {
                myVideoFailed();
            }
        });
    }

    return $video;
}

function myVideoCommand($video, command) {
    const media = $video.find("video, iframe")[0];

    if (media.tagName === "VIDEO") {
        if (command === "mute") {
            media.muted = true;
        }
        if (command === "unMute") {
            media.muted = false;
        }
        if (command === "pause") {
            media.pause();
        } else if (media.paused && !$video.hasClass("is-paused")) {
            myVideoPlay(media);
        }
        return;
    }

    if ($video.hasClass("is-click")) {
        if (command === "pause") {
            myYoutubeStop($video);
        }
        return;
    }

    if (!media.getAttribute("src")) {
        if (command === "play") {
            media.setAttribute("src", media.getAttribute("data-src"));
        }
        return;
    }

    // YouTube po pauze a novém spuštění ukáže vlastní ovládání, schované video proto jen ztichne a hraje dál
    if (command === "pause") {
        myYoutubeMessage(media, "mute");
        return;
    }

    if (command === "play" && $video.hasClass("is-sound") && (!media.dataset.soundLater || $video.hasClass("is-playing"))) {
        delete media.dataset.soundLater;
        myYoutubeSoundRestore(media, $video);
    }
    myYoutubeMessage(media, { play: "playVideo", mute: "mute", unMute: "unMute" }[command]);
    if (command === "unMute") {
        myYoutubeMessage(media, "playVideo");
    }
}

// Mobil: YouTube se pouští až klepnutím a nikdy neběží schovaný (Safari schovanému videu zastaví obraz, zvuk hraje dál)
function myYoutubeStart($video) {
    const youtubeId = $video.data("youtubeId");
    $video.addClass("is-started");
    $video.find("iframe").attr("src", "https://www.youtube.com/embed/" + youtubeId + "?autoplay=1&mute=1&controls=1&playsinline=1&rel=0&modestbranding=1&enablejsapi=1&start=" + Math.floor($video.data("time") || 0));
}

function myYoutubeStop($video) {
    if ($video.hasClass("is-started")) {
        $video.removeClass("is-started");
        $video.find("iframe").attr("src", "about:blank");
    }
}

function myYoutubeMessage(iframe, func, args) {
    iframe.contentWindow.postMessage(JSON.stringify({ event: "command", func: func, args: args || [] }), "https://www.youtube.com");
}

// Zvuk se vrací, dokud ho přehrávač nepotvrdí; když ho prohlížeč nepovolí, ikona se po 3 s přepne na ztlumeno
function myYoutubeSoundRestore(iframe, $video) {
    iframe.dataset.soundRestore = "1";
    myYoutubeMessage(iframe, "unMute");
    setTimeout(function () {
        if (iframe.dataset.soundRestore) {
            delete iframe.dataset.soundRestore;
            myVideoSound($video, false);
        }
    }, 3000);
}

// Prohlížeč, který nepustí přehrávání se zvukem, dostane video ztlumené
function myVideoPlay(media) {
    media.play().catch(function (error) {
        if (error && error.name === "NotAllowedError" && !media.muted) {
            media.muted = true;
            media.play().catch(function () {});
        }
    });
}

function myVideoSoundState($video, soundOn) {
    $video.toggleClass("is-sound", soundOn);
    $video.find(".mygallery-video-sound").attr("aria-label", soundOn ? videoTexts.soundOff : videoTexts.soundOn);
}

function myVideoSound($video, soundOn) {
    myVideoCommand($video, soundOn ? "unMute" : "mute");
    myVideoSoundState($video, soundOn);
}

// Stav YouTube přehrávače: náhled schová jen skutečné přehrávání
window.addEventListener("message", function (e) {
    if (!galleryVideo || e.origin !== "https://www.youtube.com") {
        return;
    }

    const iframe = galleryVideo.find("iframe")[0];
    if (!iframe || e.source !== iframe.contentWindow) {
        return;
    }

    let data;
    try {
        data = JSON.parse(e.data);
    } catch (error) {
        return;
    }

    if (data && data.event === "onError") {
        myVideoFailed();
        return;
    }

    const info = data && data.info;
    if (galleryVideo.hasClass("is-click")) {
        if (!galleryVideo.hasClass("is-started")) {
            return;
        }
        if (info && typeof info.currentTime === "number") {
            galleryVideo.data("time", info.currentTime);
        }
        if (data.event === "initialDelivery" || data.event === "onReady") {
            myYoutubeMessage(iframe, "unMute");
            myYoutubeMessage(iframe, "playVideo");
        }
        return;
    }

    let state = null;
    if (data.event === "onStateChange" && typeof info === "number") {
        state = info;
    } else if (data.event === "infoDelivery" && info && typeof info.playerState === "number") {
        state = info.playerState;
    }

    if (info && typeof info.muted === "boolean" && !galleryVideo.hasClass("is-paused") && !iframe.dataset.soundLater) {
        if (iframe.dataset.soundRestore && info.muted) {
            myYoutubeMessage(iframe, "unMute");
        } else {
            delete iframe.dataset.soundRestore;
            myVideoSoundState(galleryVideo, !info.muted);
        }
    }

    if (state === null) {
        return;
    }

    // Náhled zmizí hned, jak video hraje; smyčku dělá skript, parametr playlist by přidal tlačítka další/předchozí
    if (state === 1 && !galleryVideo.hasClass("is-playing")) {
        galleryVideo.addClass("is-playing");
        if (iframe.dataset.soundLater && !galleryVideo.hasClass("is-paused")) {
            delete iframe.dataset.soundLater;
            myYoutubeSoundRestore(iframe, galleryVideo);
        }
    } else if (state === 0) {
        myYoutubeMessage(iframe, "seekTo", [0, true]);
        myYoutubeMessage(iframe, "playVideo");
    } else if (state === 2 || (state !== 1 && !galleryVideo.hasClass("is-playing"))) {
        galleryVideo.removeClass("is-playing");
    }
    if (state === 2 && !galleryVideo.hasClass("is-paused") && galleryVideo.hasClass("is-sound")) {
        myVideoSound(galleryVideo, false);
        myVideoCommand(galleryVideo, "play");
    }
});

// Nenačtené video zmizí a galerie vypadá jako bez něj
function myVideoFailed() {
    if (!galleryVideo) {
        return;
    }

    const $video = galleryVideo;
    const $gallery = $video.closest(".mobile-gallery");
    galleryVideo = null;
    $(".mygallery-video-cbox, .mygallery-cbox-photo").remove();
    $(".p-image").off("click.mygalleryvideo");
    console.warn("Video v galerii: video se nepodařilo načíst nebo nemá obraz", $video.data("url"));

    if ($gallery.length) {
        const swiper = $gallery.find(".mobile-gallery-swiper")[0].swiper;
        const $slide = $video.closest(".swiper-slide");

        if (!swiper) {
            $slide.remove();
            return;
        }

        const videoIndex = parseInt($slide.attr("data-swiper-slide-index"), 10);
        const activeIndex = swiper.realIndex > videoIndex ? swiper.realIndex - 1 : swiper.realIndex;
        swiper.removeSlide(isNaN(videoIndex) ? $slide.index() : videoIndex);

        if (swiper.slides.length < 2) {
            $gallery.addClass("mobile-gallery--single");
        } else {
            swiper.slideToLoop(activeIndex, 0, false);
        }
        return;
    }

    const $holder = $video.closest(".img-holder");
    const $thirdPhoto = $(".p-thumbnails .p-thumbnail").eq(2);
    if ($thirdPhoto.length) {
        $holder.removeClass("is-video").empty().append(myGalleryPhoto($thirdPhoto));
    } else {
        $holder.closest(".additional-gallery").remove();
    }
}

function myVideoRatio(href) {
    const size = String(href || "").match(/[?&](?:amp;)?x=(\d+)&(?:amp;)?y=(\d+)/);
    if (size) {
        return size[1] + " / " + size[2];
    }

    const $img = $(".p-image .p-main-image img");
    return $img.attr("width") && $img.attr("height") ? $img.attr("width") + " / " + $img.attr("height") : "";
}

// Video v okně fotek (colorbox) na stejné pozici jako v galerii
function myVideoColorboxSize(axis) {
    const width = Math.min(shoptet.modal.config.widthLg, Math.floor(window.innerWidth * parseFloat(shoptet.modal.config.maxWidth) / 100)) - 2;
    if (axis === "x") {
        return width;
    }

    let ratio = parseFloat(galleryVideo[0].style.getPropertyValue("--mygallery-video-ratio"));
    const media = galleryVideo.find("video")[0];
    if (media && media.videoWidth) {
        ratio = media.videoWidth / media.videoHeight;
    }

    const height = Math.floor(window.innerHeight * parseFloat(shoptet.modal.config.maxHeight) / 100) - 36;
    return ratio ? Math.min(height, Math.round(width / ratio)) : height;
}

function myVideoColorboxContent() {
    const $content = $("<div class='mygallery-cbox'></div>");
    const youtubeId = galleryVideo.data("youtubeId");
    const soundOn = galleryVideo.hasClass("is-sound");

    if (youtubeId) {
        $("<iframe frameborder='0'></iframe>").attr({
            "src": "https://www.youtube.com/embed/" + youtubeId + "?autoplay=1&mute=" + (soundOn ? 0 : 1) + "&controls=1&playsinline=1&rel=0&modestbranding=1",
            "title": $(".p-detail-inner-header h1").text().trim() || "Video",
            "allow": "autoplay; encrypted-media; picture-in-picture; fullscreen",
        }).appendTo($content);
    } else {
        const $media = $("<video controls playsinline autoplay loop></video>").attr("src", galleryVideo.data("url"));
        $media[0].muted = !soundOn;
        $media.appendTo($content);
    }

    return $content;
}

function myVideoColorbox() {
    const $groupLinks = $(".p-thumbnails a.cbox-gal[data-gallery]");
    const galleryRel = $groupLinks.first().attr("data-gallery") || "mygallery-video";
    const $videoLink = $("<a href='#' class='mygallery-video-cbox' aria-hidden='true' tabindex='-1'></a>");
    let galleryVideoResume = false;

    if ($groupLinks.length > 2) {
        $videoLink.insertAfter($groupLinks.eq(1));
    } else if ($groupLinks.length) {
        $videoLink.insertAfter($groupLinks.last());
    } else {
        $videoLink.appendTo(".p-image");
    }

    // Produkt s jedinou fotkou nemá skupinu fotek, hlavní fotka se otevře spolu s videem
    if (!$groupLinks.length && $(".p-image .p-main-image[href]").length) {
        const $photoLink = $("<a class='mygallery-cbox-photo' aria-hidden='true' tabindex='-1'></a>")
            .attr("href", $(".p-image .p-main-image[href]").first().attr("href"))
            .insertBefore($videoLink);

        $photoLink.colorbox({
            rel: galleryRel,
            photo: true,
            width: shoptet.modal.config.widthLg,
            maxWidth: shoptet.modal.config.maxWidth,
            maxHeight: shoptet.modal.config.maxHeight,
            className: shoptet.modal.config.classLg + " productDetail",
        });

        $(".p-image").on("click.mygalleryvideo", ".p-main-image", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $photoLink.trigger("click");
        });
    }

    $videoLink.colorbox({
        rel: galleryRel,
        html: myVideoColorboxContent,
        innerWidth: function () {
            return myVideoColorboxSize("x");
        },
        innerHeight: function () {
            return myVideoColorboxSize("y");
        },
        scrolling: false,
        maxWidth: shoptet.modal.config.maxWidth,
        maxHeight: shoptet.modal.config.maxHeight,
        className: shoptet.modal.config.classLg + " productDetail",
    });

    $(document).on("cbox_open", function () {
        if (galleryVideo && !galleryVideo.hasClass("is-paused")) {
            galleryVideoResume = true;
            galleryVideo.addClass("is-paused");
            myVideoCommand(galleryVideo, "pause");
        }
    });

    $(document).on("cbox_load cbox_cleanup", function () {
        $(".mygallery-cbox video").each(function () {
            this.pause();
        });
        $(".mygallery-cbox iframe").attr("src", "about:blank");
    });

    $(document).on("cbox_complete", function () {
        $("#cboxLoadedContent .mygallery-cbox video").each(function () {
            myVideoPlay(this);
        });
    });

    $(document).on("cbox_closed", function () {
        if (galleryVideo && galleryVideoResume) {
            galleryVideo.removeClass("is-paused");
            myVideoCommand(galleryVideo, "play");
        }
        galleryVideoResume = false;
    });
}

// Dlaždice fotky vedle hlavního obrázku otevírá Shoptetí skupinu fotek, aby v okně nebyla podruhé
function myGalleryPhoto($thumbnail) {
    const $img = $thumbnail.find("img");
    const alt = $img.attr("alt") || "";
    const src = myImageSize($img.attr("data-src") || $img.attr("src"), "big");
    return $("<a class='mygallery-link'></a>").attr({ href: $thumbnail.attr("href"), "data-alt": alt }).append($("<img>").attr({ src: src, alt: alt, loading: "lazy" }));
}

// Přečte parametr Video, řádek v tabulce parametrů skryje
function myGalleryVideoInit() {
    videoTexts = $.extend({ soundOn: "Zapnout zvuk videa", soundOff: "Vypnout zvuk videa", play: "Přehrát video" }, (typeof shopDataLayer !== "undefined" && shopDataLayer.productDetail && shopDataLayer.productDetail.video) || {});

    $(".extended-description .detail-parameters tr").each(function () {
        if (!$(this).children("th").text().toLowerCase().includes("video")) {
            return;
        }

        $(this).addClass("no-display");
        const $td = $(this).children("td");
        const videoUrl = ($td.find("a[href]").first().attr("href") || $td.text()).trim();
        if (videoUrl && !galleryVideo) {
            galleryVideo = myGalleryVideo(videoUrl);
        }
    });

    $(".extended-description").each(function () {
        if (!$(this).find(".detail-parameters tr").not(".no-display").length) {
            $(this).addClass("no-display");
        }
    });

    return galleryVideo;
}

// Desktop: video do pravé dlaždice vedle hlavní fotky, hraje hned
function myGalleryVideoDesktop(ratioHref) {
    const $thumbnails = $(".p-thumbnails .p-thumbnail");
    let $gallery = $(".additional-gallery");

    $gallery.find("a[data-gallery]").each(function () {
        $.removeData(this, "colorbox");
        $(this).removeAttr("data-gallery").removeClass("cbox-gal cboxElement").addClass("mygallery-link");
    });

    if (!$gallery.length) {
        $gallery = $("<div class='additional-gallery'></div>").insertAfter(".p-image");
        if ($thumbnails.length >= 2) {
            $("<div class='img-holder'></div>").append(myGalleryPhoto($thumbnails.eq(1))).appendTo($gallery);
        }
    }

    let $holder = $gallery.children(".img-holder").eq(1);
    if (!$holder.length) {
        $holder = $("<div class='img-holder'></div>").appendTo($gallery);
    }

    galleryVideo.css("aspect-ratio", myVideoRatio(ratioHref));
    $holder.empty().addClass("is-video").append(galleryVideo);

    const $iframe = galleryVideo.find("iframe");
    if ($iframe.length) {
        $iframe.attr("src", $iframe.attr("data-src"));
    }

    myVideoColorbox();
}

// Mobil: video jako 3. slide (u méně fotek na konci), hraje jen když je slide vidět
function myGalleryVideoMobile(ratioHref) {
    const $gallery = $(".mobile-gallery");
    const swiper = $gallery.find(".mobile-gallery-swiper")[0] && $gallery.find(".mobile-gallery-swiper")[0].swiper;
    if (!swiper) {
        galleryVideo = null;
        return;
    }

    galleryVideo.addClass("is-paused").css("aspect-ratio", myVideoRatio(ratioHref));
    galleryVideo.find("video").removeAttr("autoplay");

    if (galleryVideo.data("youtubeId")) {
        galleryVideo.addClass("is-click").append($("<button type='button' class='mygallery-video-play'></button>").attr("aria-label", videoTexts.play));
    }

    const $slide = $("<div class='swiper-slide mygallery-video-slide'></div>").append(galleryVideo);
    swiper.addSlide(Math.min(2, swiper.slides.length), $slide[0]);
    swiper.slideToLoop(0, 0, false);
    $gallery.removeClass("mobile-gallery--single");

    function myVideoVisibility() {
        if (!galleryVideo || swiper.destroyed || !galleryVideo.closest(".mobile-gallery").length) {
            return;
        }

        const slide = galleryVideo.closest(".swiper-slide")[0].getBoundingClientRect();
        const box = swiper.el.getBoundingClientRect();
        const visible = Math.min(slide.right, box.right) - Math.max(slide.left, box.left);
        const isVisible = slide.width > 0 && visible / slide.width >= 0.5;

        if (isVisible && galleryVideo.hasClass("is-paused")) {
            galleryVideo.removeClass("is-paused");
            myVideoCommand(galleryVideo, "play");
        } else if (!isVisible && !galleryVideo.hasClass("is-paused")) {
            galleryVideo.addClass("is-paused");
            myVideoCommand(galleryVideo, "pause");
        }
    }

    swiper.on("transitionEnd resize", myVideoVisibility);
    myVideoVisibility();
}

$(document).ready(function () {
    if (!$("body").hasClass("mydemo-product") || !myGalleryVideoInit()) {
        return;
    }

    const $thumbnails = $(".p-thumbnails .p-thumbnail");
    const ratioHref = $thumbnails.eq(1).attr("href") || $thumbnails.first().attr("href");

    if ($(window).width() > 1199) {
        myGalleryVideoDesktop(ratioHref);
    } else {
        myGalleryVideoMobile(ratioHref);
    }

    $(document).on("click", ".additional-gallery .mygallery-link", function (e) {
        e.preventDefault();
        const href = $(this).attr("href");
        $(".p-thumbnails a.cbox-gal").filter(function () {
            return $(this).attr("href") === href;
        }).first().trigger("click");
    });

    $(document).on("click", ".mygallery-video-sound", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $video = $(this).closest(".mygallery-video");
        myVideoSound($video, !$video.hasClass("is-sound"));
    });

    // Desktop: klik na video otevře okno s fotkami na videu; mobil: klepnutí spustí YouTube, u vlastního videa přepne zvuk
    $(document).on("click", ".mygallery-video", function (e) {
        e.preventDefault();
        if ($(this).hasClass("is-click")) {
            if (!$(this).hasClass("is-started")) {
                myYoutubeStart($(this));
            }
        } else if ($(this).closest(".mobile-gallery").length || !$(".mygallery-video-cbox").length) {
            myVideoSound($(this), !$(this).hasClass("is-sound"));
        } else {
            $(".mygallery-video-cbox").trigger("click");
        }
    });
});
